import styled from "styled-components";

export const SinglePageWrapper = styled.div`
  .card-background {
    background: var(--strechedContainer);
  }

  .single-page-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    column-gap: 10px;
    margin: auto auto 150px auto;
    width: var(--smallWidth);
    max-width: var(--fullWidth);
  }

  .grid-first {
    width: 100%;
    margin-top: 50px;
  }

  .grid-second {
    width: 100%;
    margin-top: 50px;
  }

  .mb-div {
    margin-bottom: 150px;
  }

  .current-location {
    display: flex;
    margin-top: 15px;
    padding: 10px;
    width: var(--widthFull);
    max-width: var(--maxWidth);
    align-items: center;
    justify-content: center;
  }

  a {
    margin: 0 5px;
    font-size: 14px;
    text-decoration: none;
    color: var(--pickSize);
  }

  .current-location a:nth-child(3) {
    background: var(--checkoutCard);
    padding: 8px;
    border-radius: 5px;
  }

  p {
    font-size: 16px;
    color: var(--checkout-product-descr);
  }

  img {
    width: 100%;
    height: 470px;
    object-fit: cover;
  }

  h5 {
    color: var(--pickSize);
    font-weight: lighter;
    font-size: 12.5px;
    text-align: center;
    margin-top: 10px;
  }

  .product-descr {
    display: block;
    padding: 5px;
    margin: 10px 0px 0px 40px;
  }

  .product-descr > .section-pick {
    display: flex;
    justify-content: space-around;
    padding: 0;
    margin-top: 25px;
  }

  .section-pick > div {
    display: block;
  }

  .footer-section {
    display: block;
    margin: 20px 0px 0px 0px;
  }

    .footer-section > .inside-footer {
    display: flex;
    justify-content: space-around;
    width: 100%;
    max-width: var(--fullWidth);
  }

  button {
    margin-left: 10px;
  }

    .footer-section >  .inside-footer > .amount-handler {
    display: flex;
    width: 100%;
    max-width: 300px;
    justify-content: space-around;
    align-items: center;
  }

  .footer-section > .quantity-div {
    margin-bottom: 20px;
  }

  svg {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  @media screen and (max-width: 320px ) {
      .current-location a {
          font-size: 12.5px;
      }
    }

    @media screen and (max-width: 550px) {
      .product-descr {
        margin: 10px 0px 0px 0px;
      }
      .product-descr > .section-pick {
        flex-direction: column;
      }
      .single-page-grid {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      }
      .footer-section > .inside-footer {
        flex-direction: column;
        justify-content: center;
        margin-top: 15px;
      }
      button {
        margin: 10px 0px 0px 0px;
      }
    }



  @media only screen and (min-width: 768px) and (min-height: 1024px) {
    h4 {
      font-size: 32px;
    }
    .product-descr {
      margin: 10px 0px 0px 0px;
    }
    p {
      font-size: 22px;
    }
    span {
      font-size: 18px;
    }
    small {
      font-size: 18px;
    }

    h5 {
      font-size: 22.3px;
    }
    .current-location a {
      font-size: 18.3px;
    }
  }

  @media only screen and (min-width: 1024px) and (min-height: 1366px) {
    .single-page-grid {
      grid-template-columns: 1fr;
    }

    svg {
      width: 25px;
      height: 25px;
    }

    .current-location a {
      font-size: 28px;
    }

    h4 {
      font-size: 42px;
    }
    
    p {
      font-size: 30px;
    }

    span {
      font-size: 30px;
    }

    .pick-size {
      margin: 0px 0px 0px 35px;
    }


    h5 {
      font-size: 28px;
      margin: 25px 0px 0px 0px;
    }

    small {
      font-size: 27px;
    }


    .checkmark {
      top: 8px;
      /* padding: 15px; */
      width: 30px;
      height: 30px;
    }

    .container-radio .checkmark:after {
    left: 7px;
    top: 8px;
    width: 15px;
    }
  }
`;
